import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CarFront } from 'lucide-react';
export function OpeningHook() {
  return <SectionWrapper className="bg-brand-darker relative overflow-hidden" data-id="element-142">
      {/* Decorative element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-brand-green/5 blur-[120px] rounded-full pointer-events-none" data-id="element-143"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-144">
        <div className="bg-brand-card border border-gray-800 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-145">
          <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mb-8" data-id="element-146">
            <CarFront className="w-8 h-8 text-red-500" data-id="element-147" />
          </div>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-148">
            <p data-id="element-149">
              <strong className="text-white font-semibold" data-id="element-150">
                Estás en el concesionario.
              </strong>{' '}
              Tienes el dinero en la mano. Has trabajado duro, doble turno, bajo
              el sol o en la oficina.
            </p>
            <p data-id="element-151">
              Pero cuando el vendedor regresa, su cara lo dice todo:{' '}
              <span className="text-red-400 font-semibold italic" data-id="element-152">
                "Lo siento, el banco no aprobó tu crédito".
              </span>
            </p>
            <p data-id="element-153">
              Ese silencio es el muro que separa a los que progresan en este
              país de los que se quedan estancados.
            </p>
            <p className="text-white font-medium text-xl md:text-2xl pt-4 border-t border-gray-800" data-id="element-154">
              No es justo que un error de hace tres años o una deuda médica te
              impida comprar la casa para tu familia o la camioneta para tu
              negocio.
            </p>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}